import React, { ReactNode } from 'react'

import { Close } from '../icons/Close'

export interface ModalProps {
  children: ReactNode
  header: {
    icon: ReactNode
    title: string
  }
  onClose: () => void
  dataTestId?: string
}

export const Modal = ({ children, header, onClose, dataTestId }: ModalProps) => {
  return (
    <div className="fixed top-0 left-0 z-30 flex h-full w-full flex-col bg-gray-background" data-testid={dataTestId}>
      <div className="flex flex-row justify-between px-4 py-6">
        <div className="flex flex-row items-center gap-4">
          {header.icon}
          <p className="text-lg font-bold text-primary">{header.title}</p>
        </div>

        <button onClick={onClose} data-testid={`${dataTestId}-close-button`}>
          <Close customClassName="text-primary" />
        </button>
      </div>

      <div className="flex flex-1 flex-col gap-6 overflow-y-auto bg-background-pattern bg-contain bg-repeat px-4 pb-4 pt-1">{children}</div>
    </div>
  )
}
